// extracted by mini-css-extract-plugin
module.exports = {"sgmEventWrapper":"_b77f435","sgmEvent":"_e4da741","sgmEventInfo":"_5d6d0b9","icon":"_3aadaf9","iconOpen":"_8845351"};